import { Flex, Img, Text } from "@chakra-ui/react";
import { Link } from "react-router-dom";
import {
  BOX_SHADOW,
  IMAGE_PATH,
  MAX_CONTENT_WIDTH,
  SITE_MIN_MARGIN,
} from "../const";
import { useAreasModalStore } from "../stores/AreasModalStore";

export const NavBar: React.FC = () => {
  const { onOpen } = useAreasModalStore(["onOpen"]);

  return (
    <Flex
      position="sticky"
      bg="white"
      top={0}
      zIndex={999}
      w="100%"
      px={{ base: 2, sm: SITE_MIN_MARGIN }}
      py={4}
      boxShadow={BOX_SHADOW}
    >
      <Flex
        gap={8}
        maxW={MAX_CONTENT_WIDTH}
        mx="auto"
        alignItems="center"
        w="100%"
      >
        <Link to="">
          <Img src={`${IMAGE_PATH}/breakfree-holiday-homes.svg`} h="32px" />
        </Link>
        <nav
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "1.5rem",
          }}
        >
          <Link to="">Home</Link>
          <Text as="span" cursor="pointer" onClick={onOpen}>
            Browse Parks
          </Text>
          <Link to="/insurance">Insurance</Link>
        </nav>
      </Flex>
    </Flex>
  );
};
